import type { ReactNode } from 'react';
import { IconAccount, IconBriefcase, IconCard, IconHelp, IconMessages, IconOverview, IconShield } from '../components/NavIcons';
import { JOURNEY } from '../lib/format';

export type NavBadgeKey = 'docIssues' | 'pendingPayments' | 'companies';

export type NavItem = {
  to: string;
  label: string;
  hint: string;
  end?: boolean;
  badge?: NavBadgeKey;
  icon: (p: { className?: string }) => ReactNode;
};

export type NavSection = {
  id: 'workspace' | 'company' | 'account';
  title: string;
  dot: string;
  /** Hidden until the customer has at least one company. */
  requiresCompany?: boolean;
  items: NavItem[];
};

/** musb is the customer workspace only — Micus analysts work in Micus Consult. Journey steps live in the company tabs, not here. */
export const NAV_SECTIONS: NavSection[] = [
  {
    id: 'workspace',
    title: 'Workspace',
    dot: '#7ef0c4',
    items: [{ to: '/', label: 'My companies', hint: 'Home', end: true, badge: 'companies', icon: IconBriefcase }],
  },
  {
    id: 'company',
    title: 'Active company',
    dot: '#ffd166',
    requiresCompany: true,
    items: [
      { to: '/overview', label: 'Overview', hint: 'Next step', icon: IconOverview },
      { to: '/verification', label: 'AI verification', hint: 'Checks', badge: 'docIssues', icon: IconShield },
      { to: '/evidence', label: 'Evidence audit', hint: 'History', icon: IconShield },
      { to: '/messages', label: 'Messages', hint: 'Analyst', icon: IconMessages },
      { to: '/payments', label: 'Payments', hint: 'Fees', badge: 'pendingPayments', icon: IconCard },
    ],
  },
  {
    id: 'account',
    title: 'Account',
    dot: 'rgba(255,255,255,0.6)',
    items: [
      { to: '/help', label: 'Help & FAQ', hint: 'Guides', icon: IconHelp },
      { to: '/account', label: 'Account settings', hint: 'Profile', icon: IconAccount },
    ],
  },
];

export const HOME_PATH = '/';

/** Routes that work on the active company — they show the journey step tabs. */
export const COMPANY_ROUTES = [
  ...NAV_SECTIONS.filter((s) => s.requiresCompany).flatMap((s) => s.items.map((i) => i.to)),
  ...JOURNEY.map((s) => s.to),
  '/ready',
];
